import * as z from 'zod'

import { api } from '../../utils/api'
import { UserSchema } from '../../models/user/user'

const InputSchema = z.tuple([])

const OutputSchema = z.promise(z.object({
	user: UserSchema
}))

const FunctionSchema = z.function(InputSchema, OutputSchema)

export const GetLogged = FunctionSchema.implement(async () => await api.get(`/user/logged`))